<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="$store.state.drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
      <v-list dense>
        <template>
          <router-link to="/eps-management-home" class="sidebar-link">
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-home</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Dashboard</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <v-divider></v-divider>

        </template>
      </v-list>
    </v-navigation-drawer>
    <eps-header :drawer="$store.state.drawer"></eps-header>
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="5">
            <v-card class="elevation-12">
              <v-toolbar color="brand" dark flat>
                <v-toolbar-title>Change Password</v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field v-model="user.oldpassword" :rules="[v => !!v || 'Old Password is required']"
                    prepend-icon=" mdi-account-key" placeholder="Old Password" :disabled="disabled == 1 ? true : false"
                    clearable :append-icon="value2 ? 'mdi-eye' : 'mdi-eye-off'" @click:append="() => (value2 = !value2)"
                    :type="value2?'password':'text'"
                    hint="In 8 digit password, Atleast 1 number, special characters and small/ capital letters required."
                    required>
                  </v-text-field>
                  <div class="error-message" v-if="error"> {{error_message}} </div>
                  <v-layout align-center justify-center v-if="hideen">
                    <v-btn class="mr-4 white--text" color="brand" @click="validateoldpassword">Check Password</v-btn>
                  </v-layout>
                  <v-text-field v-if="!hideen" v-model="user.password" :rules="[v => !!v || 'Password is required']"
                    prepend-icon=" mdi-account-key" placeholder="Password" clearable
                    :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'" @click:append="() => (value = !value)"
                    :type="value ? 'password' : 'text'"
                    hint="In 8 digit password, Atleast 1 number, special characters and small/ capital letters required."
                    required>
                  </v-text-field>
                  <v-text-field v-if="!hideen" v-model="user.confirmpassword"
                    :rules="[v => !!v || 'Confirm Password is required']" prepend-icon=" mdi-account-key"
                    placeholder="Confirm Password" clearable :append-icon="value1 ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="() => (value1 = !value1)" :type="value1 ? 'password' : 'text'"
                    hint="In 8 digit password, Atleast 1 number, special characters and small/ capital letters required."
                    required>
                  </v-text-field>
                  <div v-if="!hideen" class="captcha-container">
                    <!-- Centered CAPTCHA image -->
                    <v-row justify="center" class="mb-2">
                      <v-col cols="auto">
                        <img :src="captchaImage" @click="loadCaptcha" class="captcha-image" />
                      </v-col>
                    </v-row>

                    <!-- Text field and verify button in same row -->
                    <v-row justify="center" align="center" class="captcha-input-row">
                      <v-col cols="auto">
                        <v-text-field v-model="userCaptcha" placeholder="Enter CAPTCHA" dense hide-details
                          class="captcha-input" prepend-inner-icon="mdi-shield-check"
                          :rules="[(v) => !!v || 'CAPTCHA is required']" outlined style="min-width: 180px;" />
                      </v-col>
                      <v-col cols="auto">
                        <v-btn color="#1976D2" dark @click="verifyCaptcha" class="captcha-verify-btn" small>
                          VERIFY
                        </v-btn>
                      </v-col>
                    </v-row>

                    <!-- CAPTCHA message -->
                    <p v-if="message" :style="{ color: success ? 'green' : 'red' }" class="captcha-message">
                      {{ message }}
                    </p>
                  </div>

                  <div class="error-message" v-if="error1"> {{error_message1}} </div>
                  <v-layout align-center justify-center v-if="!hideen">
                    <v-btn class="mr-4 white--text" color="brand" @click="setpassword">Change Password</v-btn>
                  </v-layout>
                </v-form>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from 'axios'
import epsHeader from "../shared/UpdatedHeader.vue";
export default {
  components: {
    epsHeader:epsHeader,
  },
    data(){
      return{
        user:{
            uid:'',
            oldpassword:'',
            password:'',
            confirmpassword:'',
        },
        value: String,
        value1: String,
        value2: String,
        captchaImage: "",
        captchaToken: "",
        userCaptcha: "",
        hideen : true,
        disabled : 0,
        message:'',
        error:false,
        error_message:'',
        error1:false,
        error_message1:'',
      }
    },
    watch: {
    userCaptcha(newValue) {
      // Clear CAPTCHA-related errors when user types or clears the CAPTCHA field
      if (this.error1 && (this.error_message1 === 'Please enter CAPTCHA' || this.error_message1 === 'Please verify CAPTCHA')) {
        this.error1 = false;
        this.error_message1 = '';
      }
    }
  },
    methods: {
      async loadCaptcha() {
        try {
          const url = process.env.VUE_APP_API_URL + `/Captcha/generate?dns=${encodeURIComponent(this.dns)}`;
          const res = await fetch(url);

          if (!res.ok) throw new Error(`HTTP ${res.status}`);

          const data = await res.json();
          console.log("CAPTCHA:", data);

          this.captchaImage = data.image;
          this.captchaToken = data.token;
          this.userCaptcha = "";
          this.message = "";
        } catch (err) {
          console.error("CAPTCHA load error:", err);
        }
      },
      async verifyCaptcha() {
        const url = process.env.VUE_APP_API_URL + `/Captcha/verify?dns=${encodeURIComponent(this.dns)}`;
        const res = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            token: this.captchaToken,
            userCaptcha: this.userCaptcha,
          }),
        });
        const result = await res.json();
        this.message = result.message;
        this.success = result.success;
        if (!result.success) {
          this.loadCaptcha();
        }
      },
    validateoldpassword() {
      if (this.perormoldPasswordFormValidation()) {
        console.log("I am in If block :: " + this.user.oldpassword);
        this.user.dns = window.location.hostname;
        this.user.uid = localStorage.getItem('EPS-uid');
        console.log("this.user.uid :: " + this.user.uid);
        axios
          .post("/login/checkpassword", this.user)
          .then(res => {
            window.console.log("res" + res.data.msg);
            if (res.data.msg == "200") {
              this.hideen = false;
              this.disabled = (this.disabled + 1) % 2
            } else {
              console.log("error :: ")
              this.message = "Password not Match!!!";
              this.error=true;
              this.error_message='Old Password not Match..!';
            }
          })
          .catch(error => {
            window.console.log(error);
            this.message = "Something went wrong";
          });
      } else {
        console.log("I am in else block :: ");
        this.error=true;
        this.error_message='Old Password not Match..!';
      }
    },
    async setpassword() {
      //  const token = await grecaptcha.execute(
      //                         "6LdpJ1orAAAAAIPDCJppHuoZgrMbHDYyGhlYqbrO",
      //                         { action: "submit" }
      //                       );
      // Check if CAPTCHA is empty or not verified
      this.error1 = false;
      this.error_message1 = '';
      if (!this.userCaptcha) {
        this.error1 = true;
        this.error_message1 = 'Please enter CAPTCHA';
        return;
      }
      if (!this.success) {
        this.error1 = true;
        this.error_message1 = 'Please verify CAPTCHA';
        return;
      }
      if (this.user.password == this.user.confirmpassword && this.user.password.length > 0 && this.user.confirmpassword.length > 0) {
        if (this.perormChangePasswordFormValidation()) {
          console.log("I am in If block :: " + this.user.password + " :: "+  this.user.confirmpassword );
          this.user.dns = window.location.hostname;
          this.user.uid = localStorage.getItem('EPS-uid');
          console.log("this.user.uid :: " + this.user.uid);
          const data = {
            user : this.user,
            // token:token
          }
          axios
            .post("/login/changepassword", data)
            .then(res => {
              window.console.log("res" + res.data.msg);
              if (res.data.msg == "200") {
                this.$router.push("/");
                //this.$router.push("/");
              } else {
                this.message = "Password not Match!!!";
                this.error1=true;
                this.error_message1='Password Not Match..!';
              }
            })
            .catch(error => {
              window.console.log(error);
              this.message = "Something went wrong";
            });
        } else {
          console.log("I am in else block :: " + this.user.password);
          this.error1=true;
          this.error_message1='Password Not Match..!';
        }
      } else {
        console.log("I am in else block :: " + this.user.password);
        this.error1=true;
        this.error_message1='Password Not Match..!';
      }
    },
    perormChangePasswordFormValidation() {
      if(this.user.password=="" && this.user.confirmpassword=="")
      {
        return false;
      }
      else{
       return true;
      }
    },
    perormoldPasswordFormValidation() {
      if(this.user.oldpassword=="")
      {
        return false;
      }
      else{
       return true;
      }
    },
    showPassword() {
        if(this.type === 'password') {
            this.type = 'text';
            this.btnText = 'Hide Password';
        } else {
            this.type = 'password';
            this.btnText = 'Show Password';
        }
    }
  },
  mounted() {
    this.message=localStorage.getItem('login-page-msg');
    this.dns = window.location.hostname;
    this.loadCaptcha();
  }
}
</script>


<style scoped>
  .sidebar-link {
    text-decoration: none;
  }
  .sidebar-link-item:hover {
    background-color: rgb(181, 186, 190) !important;
  }
  .pull-right{
      position: relative;
      text-align: center;
  }
  .error-message {
    color : red;
    font-size : 14px;
    font-weight : 900;
    padding-left : 7%;
  }
  .captcha-container {
  text-align: center;
}

.captcha-image {
  cursor: pointer;
  max-height: 50px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.captcha-input-row {
  margin-top: 5px;
  margin-bottom: 5px;
}

.captcha-message {
  margin-top: 5px;
  font-weight: bold;
}

</style>